module.exports = __webpack_public_path__ + "media/wyposazenie/kraj-pochodzenia@3x-55b3f305.svg";